
const digest = '3623b9840d0759b6af0dded27a2aaf1457799bbd717a1a1d27f5f1e377cb72da';
const classes = {"wrapper":"_wrapper_19fa7_1","title":"_title_19fa7_13","invoice":"_invoice_19fa7_17","name":"_name_19fa7_23","rightPart":"_rightPart_19fa7_27","amount":"_amount_19fa7_30"};
const css = `._wrapper_19fa7_1 {
  background-color: #fff;
  border-radius: 15px;
  padding: 20px;
  display: flex;
  flex-direction: row;
  gap: 20px;
  box-shadow: 0px 3px 5px 0 rgba(68, 70, 105, 0.15);
  justify-content: space-between;
  font-size: 14px;
  margin-bottom: 15px;
}
._wrapper_19fa7_1 ._title_19fa7_13 {
  font-size: 16px;
  font-weight: 600;
}
._wrapper_19fa7_1 ._invoice_19fa7_17 {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}
._wrapper_19fa7_1 ._invoice_19fa7_17 ._name_19fa7_23 {
  font-size: 14px;
  font-family: Poppins, sans-serif;
}
._wrapper_19fa7_1 ._rightPart_19fa7_27 {
  text-align: right;
}
._wrapper_19fa7_1 ._rightPart_19fa7_27 ._amount_19fa7_30 {
  font-weight: 600;
  font-size: 18px;
  color: #6549f0;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  